export const SET_COLORS = "PERSONALIZATION:SET_COLORS";
export const RESTORE_DEFAULT_COLORS = "PERSONALIZATION:RESTORE_DEFAULT_COLORS";
export const RECEIVE_PERSONALIZATION =
  "PERSONALIZATION:RECEIVE_PERSONALIZATION";
export const RECEIVE_SERVER_PERSONALIZATION =
  "PERSONALIZATION:RECEIVE_SERVER_PERSONALIZATION";
export const UPDATE_PERSONALIZATION = "PERSONALIZATION:UPDATE_PERSONALIZATION";
export const UPDATE_PERSONALIZATION_TITLE = "PERSONALIZATION:UPDATE_TITLE";
export const UPDATE_PERSONALIZATION_INFO = "PERSONALIZATION:UPDATE_INFO";
export const IS_FETCHING_PERSONALIZATION =
  "PERSONALIZATION:IS_FETCHING_PERSONALIZATION";
export const UPDATE_PERSONALIZATION_STATE = "PERSONALIZATION:UPDATE_STATE";
export const UPDATE_PERSONALIZATION_HAS_ERROR = "PERSONALIZATION:HAS_ERROR";
